import { render } from "./SelectCategoryBR3.vue?vue&type=template&id=17f263b2&scoped=true"
import script from "./SelectCategoryBR3.vue?vue&type=script&lang=js"
export * from "./SelectCategoryBR3.vue?vue&type=script&lang=js"

import "./SelectCategoryBR3.vue?vue&type=style&index=0&id=17f263b2&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f263b2"]])

export default __exports__